module.exports = fox => {

	require('./templates/popups.a.tpl')(fox);

	require('@centro/security-client');
	require('./stylus/_security_custom');
	require('./stylus/_dac7_form');
	require('./widget/formPopup.es')(fox);
	require('./widget/passPopup.es')(fox);
	require('./widget/setupPopup.es')(fox);
	require('./widget/protectPopup.es')(fox);
	require('./widget/requestPopup.es')(fox);
	require('./widget/securityData.es')(fox);
	require('./widget/forgotPopup.es')(fox);

}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/security-payment-details/index.es.js